var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe09(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4253.11,-1.14844 H -1.10938 V 4253.18 H 4253.11 V -1.14844",
    style: {
      fill: "#f25a1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 635.121,3549.29 c -2.527,-48.02 -22.742,-78.37 -68.262,-78.37 -49.257,0 -68.281,30.35 -68.281,86.01 v 149.2 c 0,54.37 20.188,85.96 69.539,85.96 48.051,0 67.004,-32.86 67.004,-85.96 z M 778.07,3680.8 c 0,132.82 -58.222,228.88 -209.953,228.88 -153.035,0 -212.41,-83.41 -212.41,-216.2 v -126.47 c 0,-140.37 55.574,-211.17 159.336,-211.17 60.691,0 97.336,27.86 118.84,69.52 h 1.238 v -184.57 c 0,-51.84 -20.242,-88.54 -72.058,-88.54 -51.868,0 -70.813,30.36 -70.813,83.48 v 56.88 H 360.707 v -45.54 c 0,-126.43 45.574,-214.95 204.91,-214.95 151.684,0 212.453,97.37 212.453,231.43 v 417.25",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1032.9,3895.68 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1176.53,3762.14 v -225.75 h -50.88 v 359.29 H 1185 l 65.19,-206.14 v 206.14 h 50.34 v -359.29 h -53 l -71,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1418.2,3585.67 c 24.91,0 34.45,14.84 34.45,36.56 v 188.14 c 0,21.19 -9.54,36.03 -34.45,36.03 h -25.43 v -260.73 z m 94.86,213.57 v -166.4 c 0,-55.12 -22.78,-96.45 -87.44,-96.45 h -93.27 v 359.29 h 93.27 c 64.66,0 87.44,-40.8 87.44,-96.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1720.29,3895.68 v -271.85 c 0,-55.65 -23.85,-91.68 -85.33,-91.68 -63.59,0 -90.08,36.03 -90.08,91.68 v 271.85 h 60.41 V 3618 c 0,-21.2 8.47,-35.51 29.67,-35.51 21.21,0 29.68,14.31 29.68,35.51 v 277.68 h 55.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1748.93,3613.76 v 48.22 h 56.17 v -49.28 c 0,-20.14 9.01,-31.8 29.68,-31.8 19.07,0 27.56,12.72 27.56,31.8 v 13.78 c 0,20.66 -8.49,33.38 -27.03,50.87 l -35.51,35.51 c -34.44,33.91 -50.34,54.58 -50.34,95.91 v 12.19 c 0,44.52 25.96,78.96 84.79,78.96 60.41,0 84.26,-29.67 84.26,-81.6 v -29.16 h -55.12 v 31.27 c 0,20.67 -9.54,30.74 -28.61,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.67 v -7.43 c 0,-20.13 11.13,-31.8 28.62,-48.75 l 38.68,-38.16 c 32.86,-33.38 48.76,-53.52 48.76,-93.27 v -17.48 c 0,-49.28 -26.5,-84.26 -87.97,-84.26 -61.47,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1936.55,3895.68 h 160.56 v -49.28 h -49.81 v -310.01 h -60.94 v 310.01 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2182.98,3846.4 v -111.81 h 20.14 c 20.67,0 29.68,10.59 29.68,29.67 v 53 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.41 v 359.29 h 87.97 c 60.95,0 83.2,-30.2 83.2,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.76,-163.22 h -63.59 l -56.71,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2323.97,3895.68 h 60.41 v -359.29 h -60.41 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2416.71,3895.68 h 144.15 v -49.28 h -83.73 v -102.81 h 59.89 v -48.75 h -59.89 v -109.17 h 83.73 v -49.28 h -144.15 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2652.55,3589.38 -30.73,-81.08 h -33.92 l 7.42,85.85 h 57.23 v -4.77",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1032.9,3395.68 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1176.53,3262.14 v -225.75 h -50.88 v 359.29 H 1185 l 65.19,-206.14 v 206.14 h 50.34 v -359.29 h -53 l -71,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1383.23,3262.14 v -225.75 h -50.88 v 359.29 h 59.35 l 65.19,-206.14 v 206.14 h 50.34 v -359.29 h -53 l -71,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1661.46,3119.58 v 192.9 c 0,21.73 -9.54,37.1 -31.26,37.1 -21.2,0 -30.74,-15.37 -30.74,-37.1 v -192.9 c 0,-21.72 9.54,-37.09 30.74,-37.09 21.72,0 31.26,15.37 31.26,37.09 z m -122.41,9.55 v 173.82 c 0,56.17 27.56,96.97 91.15,96.97 64.12,0 91.68,-40.8 91.68,-96.97 v -173.82 c 0,-55.65 -27.56,-96.98 -91.68,-96.98 -63.59,0 -91.15,41.33 -91.15,96.98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1936.53,3395.68 -68.36,-359.29 h -65.72 l -68.36,359.29 h 61.47 l 41.34,-250.66 h 0.53 l 42.39,250.66 h 56.71",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1993.25,3150.32 h 48.22 l -23.85,144.15 h -0.53 z m -75.79,-113.93 67.84,359.29 h 68.89 l 68.36,-359.29 h -62 l -11.13,65.71 h -64.12 l -10.6,-65.71 h -57.24",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2111.45,3395.68 h 160.57 v -49.28 h -49.82 v -310.01 h -60.94 v 310.01 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2297.46,3395.68 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2512.63,3119.58 v 192.9 c 0,21.73 -9.54,37.1 -31.26,37.1 -21.2,0 -30.74,-15.37 -30.74,-37.1 v -192.9 c 0,-21.72 9.54,-37.09 30.74,-37.09 21.72,0 31.26,15.37 31.26,37.09 z m -122.41,9.55 v 173.82 c 0,56.17 27.56,96.97 91.15,96.97 64.12,0 91.68,-40.8 91.68,-96.97 v -173.82 c 0,-55.65 -27.56,-96.98 -91.68,-96.98 -63.59,0 -91.15,41.33 -91.15,96.98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2655.74,3262.14 v -225.75 h -50.88 v 359.29 h 59.35 l 65.19,-206.14 v 206.14 h 50.34 v -359.29 h -53 l -71,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3039.96,3395.68 v -271.85 c 0,-55.65 -23.84,-91.68 -85.31,-91.68 -63.59,0 -90.1,36.03 -90.1,91.68 v 271.85 h 60.42 V 3118 c 0,-21.2 8.48,-35.51 29.68,-35.51 21.19,0 29.67,14.31 29.67,35.51 v 277.68 h 55.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3122.66,3262.14 v -225.75 h -50.88 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.34 v -359.29 h -52.99 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3364.33,3085.67 c 24.91,0 34.45,14.84 34.45,36.57 v 188.13 c 0,21.19 -9.54,36.03 -34.45,36.03 h -25.43 v -260.73 z m 94.86,213.57 v -166.4 c 0,-55.12 -22.78,-96.45 -87.44,-96.45 h -93.27 v 359.29 h 93.27 c 64.66,0 87.44,-40.8 87.44,-96.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1032.9,2895.68 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1176.53,2762.14 v -225.75 h -50.88 v 359.29 H 1185 l 65.19,-206.14 v 206.14 h 50.34 v -359.29 h -53 l -71,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1332.35,2895.68 h 141.49 v -49.28 h -81.07 v -102.81 h 60.41 v -48.75 h -60.41 v -158.45 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1558.12,2846.4 v -111.82 h 20.14 c 20.66,0 29.67,10.6 29.67,29.68 v 53 c 0,19.6 -9.01,29.14 -29.67,29.14 z m 0,-145.2 v -164.81 h -60.42 v 359.29 h 87.97 c 60.95,0 83.2,-30.2 83.2,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.76,-163.22 h -63.59 l -56.7,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1765.35,2650.32 h 48.22 l -23.85,144.15 h -0.53 z m -75.79,-113.93 67.84,359.29 h 68.89 l 68.36,-359.29 h -62 l -11.13,65.71 h -64.12 l -10.6,-65.71 h -57.24",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1908.45,2613.76 v 48.22 h 56.17 v -49.28 c 0,-20.14 9.01,-31.8 29.68,-31.8 19.07,0 27.56,12.72 27.56,31.8 v 13.77 c 0,20.67 -8.49,33.39 -27.03,50.88 l -35.51,35.51 c -34.44,33.91 -50.34,54.58 -50.34,95.91 v 12.19 c 0,44.52 25.97,78.96 84.79,78.96 60.41,0 84.26,-29.67 84.26,-81.6 v -29.15 h -55.12 v 31.26 c 0,20.67 -9.54,30.74 -28.61,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.68 v -7.42 c 0,-20.13 11.13,-31.79 28.62,-48.75 l 38.68,-38.16 c 32.86,-33.38 48.76,-53.52 48.76,-93.26 v -17.49 c 0,-49.29 -26.5,-84.26 -87.97,-84.26 -61.47,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2096.07,2895.68 h 160.57 v -49.28 h -49.81 v -310.01 h -60.95 v 310.01 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2342.5,2846.4 v -111.82 h 20.14 c 20.67,0 29.68,10.6 29.68,29.68 v 53 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.41 v 359.29 h 87.97 c 60.95,0 83.21,-30.2 83.21,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.23,-69.42 l 57.76,-163.22 h -63.59 l -56.71,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2658.9,2895.68 v -271.85 c 0,-55.65 -23.85,-91.68 -85.31,-91.68 -63.6,0 -90.1,36.03 -90.1,91.68 v 271.85 h 60.42 V 2618 c 0,-21.2 8.48,-35.51 29.68,-35.51 21.19,0 29.67,14.31 29.67,35.51 v 277.68 h 55.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2751.14,2711.26 v -174.87 h -60.42 v 359.29 h 60.42 v -157.92 l 65.71,157.92 h 59.35 l -69.96,-161.63 71.55,-197.66 h -63.6 l -63.05,174.87",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2891.06,2895.68 h 160.56 v -49.28 h -49.81 v -310.01 h -60.94 v 310.01 h -49.81 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3252.49,2895.68 v -271.85 c 0,-55.65 -23.84,-91.68 -85.32,-91.68 -63.59,0 -90.09,36.03 -90.09,91.68 v 271.85 h 60.41 V 2618 c 0,-21.2 8.48,-35.51 29.68,-35.51 21.2,0 29.68,14.31 29.68,35.51 v 277.68 h 55.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3344.72,2846.4 v -111.82 h 20.14 c 20.67,0 29.67,10.6 29.67,29.68 v 53 c 0,19.6 -9,29.14 -29.67,29.14 z m 0,-145.2 v -164.81 h -60.41 v 359.29 h 87.97 c 60.95,0 83.2,-30.2 83.2,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.75,-163.22 h -63.58 l -56.71,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3003.38,705.852 2609.52,478.551 V 933.23 l 393.86,227.4 z M 1702.26,478.551 V 898.68 l 363.86,-210.11 z m -59.84,0 -393.8,227.301 v 454.778 l 393.8,-227.4 z m 423.7,1257.709 -363.86,-210.11 v 420.18 z m 483.55,-210.09 -363.82,210.09 363.82,210.07 z m -363.82,-313.71 393.74,227.29 393.84,-227.28 -393.84,-227.388 z m -89.78,51.84 -363.86,210.03 363.86,210.1 z m 423.65,210.02 -363.81,-210.01 v 420.12 z m -423.65,-733.91 -363.88,210.11 363.88,210.11 z m 952.2,497.99 -438.75,253.21 v 506.56 c 0,10.69 -5.7,20.57 -14.97,25.92 l -453.6,261.9 c -9.28,5.33 -20.65,5.33 -29.92,0 l -453.65,-261.9 c -9.27,-5.35 -14.96,-15.23 -14.96,-25.92 V 1491.61 L 1203.73,1238.4 c -9.27,-5.36 -14.96,-15.23 -14.96,-25.93 v -523.9 c 0,-10.691 5.69,-20.57 14.96,-25.922 l 453.65,-261.847 c 4.64,-2.672 9.79,-4.02 14.97,-4.02 5.16,0 10.32,1.348 14.95,4.02 l 438.69,253.211 438.64,-253.211 c 4.63,-2.672 9.79,-4.02 14.96,-4.02 5.18,0 10.33,1.34 14.96,4.02 l 453.72,261.847 c 9.27,5.34 14.96,15.231 14.96,25.922 v 523.9 c 0,10.7 -5.69,20.59 -14.96,25.93",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe09);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-09.b9f179eeb4eb0ea2c64b87d6dfb856a7.svg";
export { ForwardRef as ReactComponent };